/* eslint-disable @typescript-eslint/no-explicit-any */
import { Breadcrumb, Table, TableTypes } from "tvs-unified-lib/dist";
import { Title } from "../styles";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDebounce } from "@/hooks";
import { uploadApi } from "@/services";
import { ColumnDef } from "@tanstack/react-table";
import { useSnackbar } from "notistack";
import {
  CardItem,
  CardStatus,
  CardStyled,
  CardTitle,
  CardValue,
  Root,
} from "./styles";

export const UploadDetail = () => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [campaignUploadFile, setCampaignUploadFile] = useState<any>();
  const [accounts, setAccounts] = useState<any>();

  const fetchData = useDebounce(async () => {
    setLoading(true);
    const params = {
      page: pageIndex + 1,
      limit: 10,
    }
    await uploadApi
      .detailFile(id as unknown as number, params)
      .then(({ data: { campaignUploadFile, accounts } }) => {
        if (!campaignUploadFile) return;
        setCampaignUploadFile(campaignUploadFile);
        setAccounts(accounts);
      })
      .catch((e) => {
        enqueueSnackbar(e, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, 500);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);

  const renderStatusColor: Record<string, any> = {
    success: {
      color: "#42AD47",
      bg: "#E7F5E8",
      text: "Successful",
    },
    processing: {
      color: "#395278",
      bg: "#E7E9ED",
      text: "In Progress",
    },
    failure: {
      color: "#EB4553",
      bg: "#FBEBF0",
      text: "Failed",
    },
  };

  const dataTable = accounts?.response?.map((item) => {
    console.log("Params", item?.accountParams);
    const accountParam = item?.accountParams?.reduce((acc, param) => {
      if (param?.type === "list") return acc;
      let value = param?.value;

      // Format numbers with commas
      if (param?.type === "amount" || param?.type === "integer" || param?.type === "float") {
        const num = Number(value);
        if (!isNaN(num)) {
          value = new Intl.NumberFormat("en-US").format(num);
        }
      }

      return {
        ...acc,
        "Customer ID": item?.customerNo,
        "Customer Name": item?.fullName,
        "Customer Mobile No": item?.phoneNumber,
        [param?.name?.replace(/\./g, "")]: value,
      };
    }, {});

    return accountParam;
  });

  console.log("Datatable", dataTable);
  const hearderTable = dataTable?.map((item) => Object.keys(item));

  console.log("Header Tbale", hearderTable);
  const columns: ColumnDef<any>[] = hearderTable?.length
    ? hearderTable[0]?.map((item) => ({
      header: () => item,
      enableSorting: false,
      accessorKey: item,
      cell: ({ getValue }: TableTypes.CellType<any>) => getValue(),
    }))
    : [];

  const handlePageChange = (page: number) => {
    setPageIndex(page);
  };

  return (
    <Root>
      <Breadcrumb
        items={[
          {
            content: <a href="/upload">Upload</a>,
            isActive: false,
          },
          {
            content: <a>{campaignUploadFile?.uploadId || "..."}</a>,
            isActive: true,
          },
        ]}
      />
      <Title>{campaignUploadFile?.uploadId || "..."}</Title>
      <CardStyled>
        <CardItem isBorder>
          <CardTitle>STATUS</CardTitle>
          <CardStatus
            bg={renderStatusColor[campaignUploadFile?.status]?.bg}
            color={renderStatusColor[campaignUploadFile?.status]?.color}
          >
            {renderStatusColor[campaignUploadFile?.status]?.text}
          </CardStatus>
        </CardItem>
        <CardItem isBorder>
          <CardTitle>TOTAL ACCOUNTS</CardTitle>
          <CardValue>{campaignUploadFile?.successCount}</CardValue>
        </CardItem>
        <CardItem>
          <CardTitle>TOTAL PARAMATERS</CardTitle>
          <CardValue>{campaignUploadFile?.excelHeaders?.length}</CardValue>
        </CardItem>
      </CardStyled>
      <div>
        <Table
          columns={columns}
          data={dataTable || []}
          totalRecords={accounts?.totalCount || 0}
          isLoading={loading}
          manualSorting={false}
          pagination={{
            pageIndex: pageIndex,
            pageSize: 10,
          }}
          enablePagination={true}
          onPageChange={handlePageChange}
          sorting={[]}
          setSorting={() => { }}
        />
      </div>
    </Root>
  );
};

export default UploadDetail;
